import { CompanyInactivePeriodDto } from '../../models/api/companyInactivePeriodDto';

export interface ICompanyFormTabState {
    year: string;
}

export interface ICompanyFormState {
    companyId: string | null;
    companyCode: string | null;
    companyName: string | null;
    companyCountry: string | null;
    defaultYear: string | null;
    tabs: { [tabId: string]: ICompanyFormTabState };
    inactivePeriods: CompanyInactivePeriodDto[];
    inactivePeriodsLoaded: boolean;
}

export const initialCompanyFormState: ICompanyFormState = {
    companyId: null,
    companyCode: null,
    companyName: null,
    companyCountry: null,
    defaultYear: null,
    tabs: {},
    inactivePeriods: [],
    inactivePeriodsLoaded: false
};
